/** Query param on instrument distribution links (`?t=`). */
export const INSTRUMENT_LINK_TOKEN_QUERY = 't' as const

export const INSTRUMENT_ONBOARDING_PATH = '/instrument/onboarding' as const

export const INSTRUMENT_INFO_PATH_PREFIX = '/instrument' as const

/** Story + identity config — 2-minute OTP resend cooldown. */
export const SP_INSTRUMENT_OTP_RESEND_COOLDOWN_SECONDS = 120

/** Policy version sent on accept (optional body field). */
export const SP_PRIVACY_POLICY_VERSION = '2024-10-24'
export const SP_TERMS_POLICY_VERSION = '2024-10-24'

export const CONSENT_DECLINE_MESSAGE =
  'You must accept the data consent to participate in surveys.'

/** Figma 75:1365 — SMS phone entry */
export const ONBOARDING_PHONE_HEADING = 'Enter Your Mobile Number'
export const ONBOARDING_PHONE_SUBTITLE =
  "Confirm your mobile number to continue. We'll send a verification code to verify it."
export const ONBOARDING_PHONE_PLACEHOLDER = 'Enter your mobile number'
export const ONBOARDING_PHONE_ERROR = 'Enter a valid US mobile number'
export const ONBOARDING_PHONE_DATASET_ERROR =
  'This mobile number is not eligible for this survey.'

/** Figma 75:1406 — OTP verify */
export const ONBOARDING_OTP_HEADING = 'Verify Your Identity'
export const ONBOARDING_OTP_SUBTITLE =
  'A verification code has been sent to your selected verification method.'

/** Figma 75:1597 / 75:1680 */
export const ONBOARDING_CONSENT_HEADING = 'Before You Begin'
export const ONBOARDING_PRIVACY_SUBTITLE = 'Please review and accept our data privacy policy'
export const ONBOARDING_TERMS_SUBTITLE = 'Please review and accept our Terms and Conditions'

/** Marketing site legal pages (opened from Create Account links in a new tab). */
export const MARKETING_TERMS_PATH = '/terms' as const
export const MARKETING_PRIVACY_PATH = '/privacy' as const
